<template>
  <Trending>
    <template #header>
      <Header />
    </template>
    <template #table>
      <Table :is-pending="isPending" :keywords="data ?? []" />
    </template>
  </Trending>
</template>

<script lang="ts" setup>
import { useQuery } from '@tanstack/vue-query';
import { computed, onMounted, watch } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';

import {
  trendingReportAvailabilityQueryOptions,
  trendingReportQueryOptions,
  useParams,
} from '@/modules/trending/composables';
import Header from '@/modules/trending/organisms/Header';
import Table from '@/modules/trending/organisms/Table';
import Trending from '@/modules/trending/templates/Trending';

const { params, updateParams } = useParams();
const {
  data: availability,
  isPending: isPendingAvailability,
} = useQuery(trendingReportAvailabilityQueryOptions());
const { data, isPending } = useQuery({
  ...trendingReportQueryOptions(computed(() => ({
    category: params.value.category,
    date: params.value.date,
    limit: 100,
    marketplace: params.value.marketplace,
    period: 'monthly',
  }))),
  enabled: () => !isPendingAvailability.value,
});

watch(availability, (availability) => {
  if (!params.value.date) {
    const item = availability[0];

    updateParams({
      ...params.value,
      category: item.categories.includes('all') ? 'all' : item.categories[0],
      date: item.date,
    }, {
      replace: true,
    });
  }
});

onBeforeRouteUpdate((to, from, next) => {
  if (to.params.date) {
    return next();
  }

  const item = availability.value?.[0];

  if (!item) {
    return next();
  }

  next({
    params: {
      ...params.value,
      category: item.categories.includes('all') ? 'all' : item.categories[0],
      date: item.date,
    },
    replace: true,
  });
});

onMounted(() => {
  if (params.value.date) {
    return;
  }

  const item = availability.value?.[0];

  if (!item) {
    return;
  }

  updateParams({
    ...params.value,
    category: item.categories.includes('all') ? 'all' : item.categories[0],
    date: item.date,
  }, {
    replace: true,
  });
});
</script>
